module.exports = __webpack_public_path__ + "static/media/accessibility.970f23a1.svg";